module.exports = __webpack_public_path__ + "media/images/tutors/PrepWorks-Sarah-Choo-e1d6014cd6d3caaec389b871fd35c6f2.jpg";